<script setup lang="ts">
import { PlusIcon } from "@gohighlevel/ghl-icons/24/outline";
import { UIButton, UITextSmMedium } from "@gohighlevel/ghl-ui";

const props = defineProps<{
  addSlideText: string;
}>();
const emit = defineEmits(["add-slide"]);
</script>

<template>
  <div class="mb-[12px] mt-[12px] flex w-full items-center">
    <div class="custom-divider__line"></div>
    <div class="shrink-0 px-[12px] py-0">
      <UIButton
        id="add-slide-button"
        variant="ghost"
        size="sm"
        :link-gray="true"
        class="add-slide-button"
        @click="emit('add-slide')"
      >
        <PlusIcon class="h-5 w-5"></PlusIcon>
        <UITextSmMedium class="pl-[5px] font-sans not-italic !leading-[20px] tracking-normal">{{
          addSlideText
        }}</UITextSmMedium>
      </UIButton>
    </div>
    <div class="custom-divider__line"></div>
  </div>
</template>

<style scoped>
.custom-divider__line {
  flex: 1;
  height: 1px;
  background-image: repeating-linear-gradient(
    to right,
    #98a2b3 0,
    #98a2b3 7px,
    transparent 8px,
    transparent 12px
  );
}

.add-slide-button {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
  color: #98a2b3 !important;
}

.add-slide-button:hover {
  border-color: #d0d5dd;
  font-weight: 600;
  color: #344054 !important;
}
</style>
